import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/EventTicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/LazyVisible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/newCommonComponent/GlobalHeaderNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/QuickContact.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/NewGlobalFooter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/NewInactivityPopup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/NewStickyFooter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cpa-new/main/new/MilesoneNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cpa-new/main/new/NewPresence.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cpa-new/visit/CairaNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/ea/new/AI_integreated.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/newPageComponent/ea/new/BannerNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/ea/new/EA_gameplan.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/ea/new/EaEquivalentNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/ea/new/JobsAtMncs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/ea/new/NewFaqSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/AiLabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
